export enum InputTypes {
  Text = 'text',
  Date = 'date',
  Textarea = 'textarea',
  Radio = 'radio',
  Checkbox = 'checkbox',
  Select = 'select',
  File = 'file',
}
